import {
  POSTING_FORM,
  POST_FORM_SUCCESS,
  POST_FORM_FAIL,
  RESET_FORM
} from '../actions/types'

const INITIAL_STATE = {
  loading: false,
  errorMsg: null,
  postSuccess: null
}

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case POSTING_FORM:
      return { ...state, postSuccess: false, loading: true }
    case POST_FORM_SUCCESS:
      return { ...state, ...INITIAL_STATE, postSuccess: true }
    case POST_FORM_FAIL:
      return { ...state, ...INITIAL_STATE, errorMsg: action.payload }
    case RESET_FORM:
      return { ...state, ...INITIAL_STATE }
    default: return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/postReducer.js